import { Box } from "@mui/material";
import { useTheme } from "../../components/context/context";
import BasicTable from "../../components/basicTable/BasicTable";

export default function Help() {
    const { fontSize } = useTheme();
    return (
        <Box sx={{}}>
            <Box sx={{ padding: "2px 0 2px 10px", marginTop: "20px", width: "100%" }}>
                <div style={{ fontSize: `${fontSize + 0.5}rem` }}>
                    Help
                </div>
                <br />
                <span style={{ fontSize: `${fontSize + 0.1}rem`, fontWeight:"bold" }}>Viewing different file formats</span>
                <div style={{ display: "flex", justifyContent: "center", width: "100%",margin:"10px 0" }}>
                    <BasicTable heading={heading} data={data} />
                </div>
                <span style={{ fontSize: `${fontSize + 0.1}rem`, fontWeight:"bold" }}>Accessibility Help</span>
                <p style={{fontSize:`${fontSize}rem`, margin:"10px 0"}}>Use the accessibility options provided by this Website to control the screen display. These options allow increasing the text spacing, changing the text size and colour scheme for clear visibility and better readability.</p>
                <span style={{ fontSize: `${fontSize + 0.1}rem`, fontWeight:"bold" }}>Text Size Icons</span>
                <p style={{fontSize:`${fontSize}rem`, margin:"10px 0"}}>Following different options are provided in the form of icons which are available on the top of each page:</p>
                <ul style={{fontSize:`${fontSize}rem`}}>
                    <li><span style={{fontWeight:"bold", marginRight:"10px"}}>A-</span>Decrease Text Size</li>
                    <li><span style={{fontWeight:"bold", marginRight:"10px"}}>A</span>Normal Text Size</li>
                    <li><span style={{fontWeight:"bold", marginRight:"10px"}}>A+</span>Increase Text Size</li>
                </ul>
            </Box>
        </Box>
    )
}

const heading = [
    {
        data: "Document Type",
        width: "40%"
    },
    {
        data: "Download",
        width: "60%"
    },
]

const data = [
    ["Portable Document Format (P.D.F.) content", <a rel="noopener noreferrer" href="http://www.adobe.com/products/acrobat/readstep2.html" style={{color:"black"}}>Adobe Acrobat Reader</a>],
    ["Word files", <a rel="noopener noreferrer" href="https://www.microsoft.com/en-in/microsoft-365/previous-versions/microsoft-word-2010" style={{color:"black"}}>Microsoft Word</a>],
    ["Excel files", <a rel="noopener noreferrer" href="https://www.microsoft.com/en-in/microsoft-365/excel" style={{color:"black"}}>Microsoft Excel</a>],
    ["PowerPoint presentations", <a rel="noopener noreferrer" href="https://www.microsoft.com/en/microsoft-365/powerpoint" style={{color:"black"}}>Microsoft PowerPoint</a>],
    ["Flash content", <a rel="noopener noreferrer" href="https://www.adobe.com/products/flashplayer/end-of-life-alternative.html" style={{color:"black"}}>Adobe Flash Player (Other Government website that opens in a new window)</a>],
    ["Audio Files", <a rel="noopener noreferrer" href="https://support.microsoft.com/en-us/windows/get-windows-media-player-81718e0d-cfce-25b1-aee3-94596b658287" style={{color:"black"}}>Windows Media Player</a>],
];